import { Injectable } from '@angular/core';
import { ConsumidorModel } from '../shared/consumidor.model';
import { GenericHttpService, ParametrosService, ConfiguracoesProjeto } from '../../../shared/index';
@Injectable()
export class ConsumidorTermoLgpdService {

    private _urlBase: string;
    private configuracao: ConfiguracoesProjeto;

    constructor(private readonly genericHttpService: GenericHttpService<ConsumidorModel>,
                private readonly parametrosService: ParametrosService) {}

    get urlBase() {
        this.configuracao = this.parametrosService.getConfiguracao();
        this._urlBase = this.configuracao.uri + 'cidadao-lgpd/';
        return this._urlBase;
    }

    aceitarTermolgpd(consumidorId: number) {
         return this.genericHttpService.putAny(this.urlBase + `consentimento`, consumidorId);
    }

    recusarTermolgpd(consumidorId: number) {
        return this.genericHttpService.putAny(this.urlBase + `recusa`, consumidorId);
   }
}



// WEBPACK FOOTER //
// ./src/app/restrito/consumidor/shared/consumidor-termo-lgpd-service.ts